import { render, staticRenderFns } from "./alertsAudit.vue?vue&type=template&id=0ac104d4&scoped=true"
import script from "./alertsAudit.vue?vue&type=script&lang=js"
export * from "./alertsAudit.vue?vue&type=script&lang=js"
import style0 from "./alertsAudit.vue?vue&type=style&index=0&id=0ac104d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac104d4",
  null
  
)

export default component.exports